import { IUser } from '../types/interfaces/IUser';

function normalizeRoleCode(user: IUser | null): string {
  return (user?.role?.code || '').trim().toLowerCase();
}

export function isAdminContext(user: IUser | null): boolean {
  const roleCode = normalizeRoleCode(user);

  if (roleCode === 'admin' || roleCode === 'superadmin') {
    return true;
  }

  // Canonical fallback for superadmin session coming from backend:
  // authenticated user without institution context.
  return Boolean(user && !user.institution);
}

export function isDoctorContext(user: IUser | null): boolean {
  return !isAdminContext(user);
}
